<template>
  <div class="">
    <div v-for="menu in menuItems" :key="menu.id" class="footer-menu__block flex flex-col gap-4">
      <div v-for="menuItem in menu.menuItems" :key="menuItem.label">
        <template v-if="menuItem.subItems?.length">
          <h5 class="footer-menu__title">{{ menuItem.label }}</h5>
          <ul>
            <li v-for="subItem in menuItem.subItems" :key="subItem.label">
              <NuxtLink
                :to="getLocalizedUrl(subItem)"
                :target="subItem.target"
                class="footer-menu__link text-regular-link"
                :aria-label="subItem.label"
                :title="t('menu.navigateTo', { label: subItem.label })"
              >
                {{ subItem.label }}
              </NuxtLink>
            </li>
          </ul>
        </template>
        <template v-else>
          <NuxtLink
            :to="getLocalizedUrl(menuItem)"
            :target="menuItem.target"
            class="footer-menu__link text-regular-link text-accent"
            :aria-label="menuItem.label"
            :title="t('menu.navigateTo', { label: menuItem.label })"
          >
            {{ menuItem.label }}
          </NuxtLink>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { Menu } from '~/types/strapi';

  defineProps<{
    menuItems: Menu[];
  }>();

  const route = useRoute();
  const { t } = useI18n();
  const getLocalizedUrl = useLocalizedUrl();
</script>

<style lang="scss" scoped></style>
